import { render } from "./AsahiProgressBar.vue?vue&type=template&id=2d491899&scoped=true&ts=true"
import script from "./AsahiProgressBar.vue?vue&type=script&lang=ts"
export * from "./AsahiProgressBar.vue?vue&type=script&lang=ts"

import "./AsahiProgressBar.vue?vue&type=style&index=0&id=2d491899&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d491899"]])

export default __exports__